function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i["return"] && (_r = _i["return"](), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
import React, { createContext, useReducer, useEffect, useCallback } from 'react';
export var NotificationContext = /*#__PURE__*/createContext({});
var reducer = function reducer(state, action) {
  switch (action.type) {
    case 'CREATE_NOTIFICATION':
      return [].concat(_toConsumableArray(state), [action.payload]);
    case 'DISMISS_NOTIFICATION':
      return state.filter(function (notification) {
        return notification.id !== action.payload.id;
      });
    default:
      return state;
  }
};
var timersReducer = function timersReducer(state, action) {
  switch (action.type) {
    case 'ADD_TIMER':
      return [].concat(_toConsumableArray(state), [action.payload]);
    default:
      return state;
  }
};
export var NotificationProvider = function NotificationProvider(_ref) {
  var children = _ref.children,
    _ref$defaultDelay = _ref.defaultDelay,
    defaultDelay = _ref$defaultDelay === void 0 ? 3000 : _ref$defaultDelay;
  var _useReducer = useReducer(reducer, []),
    _useReducer2 = _slicedToArray(_useReducer, 2),
    state = _useReducer2[0],
    dispatch = _useReducer2[1];
  var _useReducer3 = useReducer(timersReducer, []),
    _useReducer4 = _slicedToArray(_useReducer3, 2),
    timers = _useReducer4[0],
    timerDispatch = _useReducer4[1];
  var createNotification = useCallback(function (notification, delay) {
    dispatch({
      type: 'CREATE_NOTIFICATION',
      payload: notification
    });
    if (notification.autoDismiss) {
      var timer = setTimeout(function () {
        dispatch({
          type: 'DISMISS_NOTIFICATION',
          payload: {
            id: notification.id
          }
        });
      }, delay || defaultDelay);
      timerDispatch({
        type: 'ADD_TIMER',
        payload: timer
      });
    }
  }, [defaultDelay]);
  var dismissNotification = function dismissNotification(id) {
    dispatch({
      type: 'DISMISS_NOTIFICATION',
      payload: {
        id: id
      }
    });
  };
  var clearAllTimers = useCallback(function () {
    timers.map(function (timer) {
      return clearTimeout(timer);
    });
  }, [timers]);
  useEffect(function () {
    return function () {
      return clearAllTimers();
    };
  }, [clearAllTimers]);
  var context = {
    createNotification: createNotification,
    dismissNotification: dismissNotification,
    notifications: state
  };
  return /*#__PURE__*/React.createElement(NotificationContext.Provider, {
    value: context
  }, children);
};
export default NotificationProvider;